// Colour-variant helpers: products named "Design — Colour" are variants of "Design".
export const baseName = (name = "") => name.split(" — ")[0];

export const variantColor = (name = "") => {
  const idx = name.indexOf(" — ");
  return idx === -1 ? null : name.slice(idx + 3);
};

// Colour label for the base product (no suffix) of each design family.
const BASE_COLOURS = {
  "Cotton Striped Maternity Midi Dress with Front Zip": "Pink",
  "Rayon Printed Maternity Feeding Dress with Centre Placket": "Maroon",
  "Rayon Striped Maternity Top with Front Button": "Grey",
};

export const colorOf = (p) =>
  variantColor(p?.name || "") || BASE_COLOURS[baseName(p?.name || "")] || "Original";

// One card per design (prefer the base product), plus how many colours exist.
export const groupVariants = (products) => {
  const byBase = new Map();
  const counts = new Map();
  for (const p of products) {
    const b = baseName(p.name);
    counts.set(b, (counts.get(b) || 0) + 1);
    const cur = byBase.get(b);
    if (!cur || (variantColor(cur.name) && !variantColor(p.name))) byBase.set(b, p);
  }
  return [...byBase.values()].map((p) => ({ product: p, colorCount: counts.get(baseName(p.name)) || 1 }));
};
